import { jsx as g, Fragment as s } from "react/jsx-runtime";
import { useSearchBarContext as S } from "../../context.js";
import { SearchSuggestionsEvent as t } from "../../types.js";
const u = ({
  renderSuggestion: n,
  value: e
}) => {
  const { commands: o } = S();
  return /* @__PURE__ */ g(s, { children: n({
    onSelectSuggestion: () => {
      o({
        type: t.SelectSuggestion,
        payload: e
      });
    },
    onRemoveSuggestion: () => {
      o({
        type: t.RemoveSuggestion,
        payload: e
      });
    }
  }) });
};
export {
  u as SuggestionItem
};
